import { BoMItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { BoMItemSatisfyActiveFilters } from 'utils/BoMItemSatisfyActiveFilters'
import { getPreviousAndNextItemByMaterialHeader } from './getPreviousAndNextItemByMaterialHeader'
import { getPreviousAndNextItemOfRoute } from './getPreviousAndNextItemOfRoute'
import { BomItemPointer } from './previousAndNextBomItemIdsSelector'

export const getPreviousAndNextItemOfProject = (state: RootAppState) => {
  let next: BomItemPointer = null

  if (!state.project.assemblyHeadersIds?.length) {
    return { previousBomItem: null, nextBomItem: null }
  }

  switch (state.project.currentView) {
    case ProjectViews.PurchaseView: {
      next = {
        bomItemId: getPreviousAndNextItemByMaterialHeader(
          state,
          state.project.materialHeadersIds.find((x) =>
            BoMItemSatisfyActiveFilters(
              state.project.filters,
              state.project.flatView[x]
            )
          )
        ).nextBomItem.bomItemId,
        bomItemType: BoMItemType.row,
      }
      break
    }
    case ProjectViews.RoutesView: {
      next = {
        bomItemId: getPreviousAndNextItemOfRoute(
          state,
          state.project.routingHeadersIds.find((x) =>
            BoMItemSatisfyActiveFilters(
              state.project.filters,
              state.project.flatView[x]
            )
          )
        ).nextBomItem.bomItemId,
        bomItemType: BoMItemType.row,
      }
      break
    }
    default: {
      next = {
        bomItemId: state.project.assemblyHeadersIds.find((x) =>
          BoMItemSatisfyActiveFilters(
            state.project.filters,
            state.project.flatView[x]
          )
        ),
        bomItemType: BoMItemType.assemblyHeader,
      }
    }
  }

  return {
    previousBomItem: null,
    nextBomItem: next,
  }
}
